import React from "react";
import NavBar from "../components/NavBar/navBar.component";
import Footer from "../components/Footer/footer.component";
import TermsOfService from "../components/TermsOfService/termsOfService";

function Terms() {
  return (
    <div>
        <NavBar/>
        <TermsOfService/>
        <Footer/>
    </div>
  )
}

export default Terms